(function () {
  'use strict';

  var VERSION = '3.0.0';
  var SHOPIFY_EVENT_PREFIX = 'complete_commando:';
  var ATTRIBUTION_KEY = 'cc_attribution_v2';
  var PENDING_LEAD_KEY = 'cc_pending_lead_v2';
  var SUCCESS_KEY = 'cc_lead_success_v2';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var CLICK_KEYS = ['gclid', 'fbclid', 'ttclid'];

  document.documentElement.setAttribute('data-cc-growth-ready', VERSION);

  function readStored(key) {
    try {
      return JSON.parse(window.sessionStorage.getItem(key) || '{}');
    } catch (error) {
      return {};
    }
  }

  function writeStored(key, value) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function removeStored(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      return;
    }
  }

  function cleanValue(value, limit) {
    return String(value || '').trim().slice(0, limit || 160);
  }

  function cleanLabel(value) {
    return cleanValue(value, 100)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function safeUrl(value) {
    try {
      return new URL(value, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function externalReferrerHost() {
    var referrer = safeUrl(document.referrer);
    if (!referrer || referrer.hostname === window.location.hostname) return '';
    return cleanValue(referrer.hostname, 120);
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var stored = readStored(ATTRIBUTION_KEY);
    var campaignFound = false;

    UTM_KEYS.concat(CLICK_KEYS).forEach(function (key) {
      var value = params.get(key);
      if (!value) return;
      stored[key] = cleanValue(value, 180);
      campaignFound = true;
    });

    if (!stored.first_landing_path) {
      stored.first_landing_path = cleanValue(window.location.pathname, 180);
      stored.first_referrer_host = externalReferrerHost();
      stored.first_seen_at = new Date().toISOString();
    }

    if (campaignFound) {
      stored.campaign_landing_path = cleanValue(window.location.pathname, 180);
      stored.campaign_seen_at = new Date().toISOString();
    }

    stored.last_page_path = cleanValue(window.location.pathname, 180);
    writeStored(ATTRIBUTION_KEY, stored);
    return stored;
  }

  var attribution = captureAttribution();

  function attributionPayload() {
    var payload = {
      first_landing_path: attribution.first_landing_path || '',
      first_referrer_host: attribution.first_referrer_host || '',
      campaign_landing_path: attribution.campaign_landing_path || ''
    };

    UTM_KEYS.concat(CLICK_KEYS).forEach(function (key) {
      if (attribution[key]) payload[key] = attribution[key];
    });

    return payload;
  }

  function publish(eventName, details) {
    var payload = Object.assign({}, attributionPayload(), details || {}, {
      page_path: window.location.pathname,
      page_title: cleanValue(document.title, 140),
      event_version: VERSION
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'cc_' + eventName }, payload));

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(SHOPIFY_EVENT_PREFIX + eventName, payload);
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'cc_' + eventName, payload);
    }

    try {
      document.dispatchEvent(new CustomEvent('complete-commando:tracking', {
        detail: { event: eventName, data: payload }
      }));
    } catch (error) {
      return payload;
    }

    return payload;
  }

  function offerFromUrl(url) {
    if (!url) return '';
    var value = (url.hostname + url.pathname).toLowerCase();
    if (value.indexOf('theobjective') !== -1 || value.indexOf('/the-objective') !== -1) return 'the-objective';
    if (value.indexOf('eliteroyalmarinescommando') !== -1 || value.indexOf('royal-marines-prep') !== -1) return 'royal-marines-prep';
    if (value.indexOf('wetheelite') !== -1) return 'we-the-elite';
    if (value.indexOf('militarypreparation') !== -1 || value.indexOf('operational-fitness-events') !== -1) return 'prep-weekend';
    if (value.indexOf('1-2-1-coaching') !== -1 || value.indexOf('whole-life-coaching') !== -1) return '1-2-1-coaching';
    if (value.indexOf('corporate-leadership-development') !== -1) return 'corporate-mentorship';
    if (value.indexOf('/collections/apparel') !== -1 || value.indexOf('/products/') !== -1) return 'apparel';
    if (value.indexOf('/pages/resources') !== -1 || value.indexOf('/pages/royal-marines-history') !== -1) return 'resources';
    return '';
  }

  function ctaLocation(anchor) {
    var explicit = anchor.getAttribute('data-cc-location');
    if (explicit) return cleanLabel(explicit);
    var section = anchor.closest('section, header, footer, nav');
    if (!section) return 'page';
    return cleanLabel(section.id || section.getAttribute('aria-label') || section.className) || 'page';
  }

  function decorateFitrLink(anchor) {
    var url = safeUrl(anchor.href);
    if (!url || !/\.fitr\.training$/i.test(url.hostname)) return url;

    var offer = offerFromUrl(url) || 'programme';
    var label = cleanLabel(anchor.getAttribute('data-cc-cta') || anchor.textContent) || 'website-cta';
    url.searchParams.set('utm_source', attribution.utm_source || 'completecommando.com');
    url.searchParams.set('utm_medium', attribution.utm_medium || 'website');
    url.searchParams.set('utm_campaign', attribution.utm_campaign || offer);
    url.searchParams.set('utm_content', attribution.utm_content || label);
    if (attribution.utm_term) url.searchParams.set('utm_term', attribution.utm_term);
    url.searchParams.set('cc_offer', offer);
    url.searchParams.set('cc_source_page', cleanLabel(window.location.pathname) || 'home');
    url.searchParams.set('cc_cta', label);
    anchor.href = url.toString();
    return url;
  }

  function leadTypeForForm(form) {
    var declared = form.querySelector('[name="contact[Lead type]"], [name="contact[Enquiry type]"]');
    if (declared && declared.value) return cleanLabel(declared.value);
    return cleanLabel(form.id || window.location.pathname || 'contact-form');
  }

  function ensureHidden(form, name, value) {
    if (!value) return;
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = cleanValue(value, 250);
  }

  function addAttributionToForm(form) {
    var fields = {
      'contact[Attribution source]': attribution.utm_source || (attribution.first_referrer_host ? 'referral' : 'direct'),
      'contact[Attribution medium]': attribution.utm_medium || (attribution.first_referrer_host ? 'referral' : 'none'),
      'contact[Attribution campaign]': attribution.utm_campaign || '',
      'contact[Attribution content]': attribution.utm_content || '',
      'contact[First landing page]': attribution.first_landing_path || '',
      'contact[Campaign landing page]': attribution.campaign_landing_path || '',
      'contact[Referrer]': attribution.first_referrer_host || '',
      'contact[Google click ID]': attribution.gclid || '',
      'contact[Meta click ID]': attribution.fbclid || '',
      'contact[TikTok click ID]': attribution.ttclid || '',
      'contact[Submitted from]': window.location.pathname
    };

    Object.keys(fields).forEach(function (name) {
      ensureHidden(form, name, fields[name]);
    });
  }

  function fallbackLeadType() {
    if (window.location.pathname.indexOf('corporate-leadership-development') !== -1) return 'corporate-enquiry';
    if (window.location.pathname.indexOf('1-2-1-coaching') !== -1) return 'coaching-application';
    return cleanLabel(window.location.pathname) || 'contact-form';
  }

  function initialiseLeadForms() {
    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      var started = false;
      var leadType = leadTypeForForm(form);
      addAttributionToForm(form);
      form.setAttribute('data-cc-lead-ready', VERSION);

      form.addEventListener('input', function () {
        if (started) return;
        started = true;
        form.setAttribute('data-cc-lead-started', 'true');
        publish('lead_start', { lead_type: leadType });
      });

      form.addEventListener('submit', function () {
        addAttributionToForm(form);
        var pending = {
          lead_type: leadType,
          form_id: form.id || '',
          submitted_from: window.location.pathname,
          submitted_at: Date.now()
        };
        writeStored(PENDING_LEAD_KEY, pending);
        form.setAttribute('data-cc-lead-submitted', 'true');
        publish('lead_submit', { lead_type: leadType });
      });
    });

    var params = new URLSearchParams(window.location.search);
    var successVisible = document.querySelector('.form-success, .cc-form__success, .ccc-form__success');
    if (params.get('contact_posted') !== 'true' && !successVisible) return;

    var pending = readStored(PENDING_LEAD_KEY);
    var leadType = pending.lead_type || fallbackLeadType();
    var successId = leadType + ':' + (pending.submitted_at || window.location.pathname);
    var successes = readStored(SUCCESS_KEY);
    if (successes[successId]) return;
    successes[successId] = Date.now();
    writeStored(SUCCESS_KEY, successes);
    removeStored(PENDING_LEAD_KEY);
    publish('lead_success', {
      lead_type: leadType,
      submitted_from: pending.submitted_from || window.location.pathname
    });
  }

  function initialiseCommerceTracking() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        publish('add_to_cart_intent', {
          offer: offerFromUrl(safeUrl(window.location.href)) || 'shopify-product'
        });
      });
    });
  }

  document.addEventListener('pointerdown', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor) decorateFitrLink(anchor);
  });

  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) return;

    var url = decorateFitrLink(anchor);
    if (!url) return;

    var label = cleanLabel(anchor.getAttribute('data-cc-cta') || anchor.textContent);
    var offer = offerFromUrl(url);
    var isFitr = /\.fitr\.training$/i.test(url.hostname);
    var actionCopy = /join|start|book|apply|request|buy|enrol|shop/.test(label);
    if (!offer || (!actionCopy && !isFitr)) return;

    var action = 'offer_click';
    if (isFitr) action = 'programme_join_click';
    if (offer === 'prep-weekend') action = 'event_booking_click';
    if (offer === '1-2-1-coaching' || offer === 'corporate-mentorship') action = 'coaching_apply_click';

    publish('offer_click', {
      action: action,
      offer: offer,
      cta: label || 'link',
      cta_location: ctaLocation(anchor),
      destination_host: cleanValue(url.hostname, 120),
      destination_path: cleanValue(url.pathname, 180)
    });
  });

  window.CompleteCommandoTracking = {
    attribution: attribution,
    publish: publish,
    version: VERSION
  };

  initialiseLeadForms();
  initialiseCommerceTracking();
})();
